import { Form, Alert, Row, Col, Button } from "react-bootstrap";
import { PaywayId, ShippingTypeId } from "../../actions/enums";
import useTenant from "../../tenant/useTenant";
import { formatPrice } from "../utilities";
interface PaymentStepProps {
  hasLiquidacionBlock: boolean;
  subTotalCart: number;
  resellerMinAmountDiscount: number;
  liquidacionItemsCount: number;
  minimumCart: number;
  minimumPurchaseAmount: number;
  paywayId: PaywayId;
  localPickup: ShippingTypeId;
  addressPickup: string;
  increase1: number;
  discount1: number;
  isResellerDiscount: boolean;
  shippingCost: number;
  incrementAmount: number;
  discountAmount: number;
  totalCart: number;
  isLoading: boolean;
  textButton: string;
  handleChangePayWay: (value: PaywayId) => void;
  handleBack: () => void;
  handleSubmit: () => void;
}

const PaymentStep = ({
  hasLiquidacionBlock,
  subTotalCart,
  resellerMinAmountDiscount,
  liquidacionItemsCount,
  minimumCart,
  minimumPurchaseAmount,
  paywayId,
  localPickup,
  addressPickup,
  increase1,
  discount1,
  isResellerDiscount,
  shippingCost,
  incrementAmount,
  discountAmount,
  totalCart,
  isLoading,
  textButton,
  handleChangePayWay,
  handleBack,
  handleSubmit,
}: PaymentStepProps) => {
  const tenant = useTenant();

  return (
    <div className="col-md-6">
      <h2>Forma de pago</h2>
      {tenant.features.hasResellerLogic &&
        hasLiquidacionBlock &&
        Number(subTotalCart) > Number(resellerMinAmountDiscount) &&
        Number(resellerMinAmountDiscount) > 0 && (
          <Alert variant="warning">
            <Alert.Heading>⚠️ Atención</Alert.Heading>
            <p>
              Tu carrito contiene{" "}
              <strong>{liquidacionItemsCount} producto(s) de LIQUIDACIÓN</strong> que
              alcanzan el mínimo de compra ({minimumCart} productos{minimumPurchaseAmount > 0 ? `, $${minimumPurchaseAmount} monto mínimo` : ""}). Los productos de
              LIQUIDACIÓN <strong>no son compatibles con el descuento de revendedor</strong>.
              Por favor, volvé al carrito, retirá esos productos y realizá una
              compra aparte para poder aplicar el descuento.
            </p>
          </Alert>
        )}
      <Form.Group>
        <Form.Label>Formas de pago</Form.Label>
        <Form.Select
          name="payway_id"
          id="payway_id"
          size="lg"
          className="mb-3"
          value={paywayId}
          onChange={(element: any) => handleChangePayWay(+element.target.value)}
        >
          <option value={PaywayId.NONE}>Seleccioná una opción</option>
          {tenant.paywayOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {localPickup === ShippingTypeId.BRANCH_PICKUP && (
        <Alert variant="success">
          <Alert.Heading>{tenant.branchName}: </Alert.Heading>
          <p>{addressPickup}</p>
        </Alert>
      )}
      {paywayId === PaywayId.CARD && (
        <Alert variant="info" id="alert-increment" className="fs-5">
          El pago tiene un incremento del {increase1}% por el costo del prestador
          de servicio
        </Alert>
      )}
      {discount1 > 0 && (
        <Alert variant="info" id="alert-discount" className="fs-5">
          {tenant.features.hasResellerLogic && isResellerDiscount
            ? `Se aplicó un descuento del ${discount1}%`
            : `El método pago tiene un descuento del ${discount1}%`}
        </Alert>
      )}
      {(shippingCost > 0 || increase1 > 0 || discount1 > 0) && (
        <Row className="fs-5">
          <Col className="col-8">Subtotal:</Col>
          <Col className="text-end col-4">${formatPrice(subTotalCart * 1)}</Col>
        </Row>
      )}
      {shippingCost > 0 && (
        <Row className="fs-5">
          <Col className="col-8">Envío:</Col>
          <Col className="text-end col-4">${formatPrice(shippingCost)}</Col>
        </Row>
      )}
      {increase1 > 0 && (
        <Row className="fs-5">
          <Col className="col-8">Costo forma de pago:</Col>
          <Col className="text-end col-4">${formatPrice(incrementAmount)}</Col>
        </Row>
      )}
      {discount1 > 0 && (
        <Row className="fs-5">
          <Col className="col-8">
            {tenant.features.hasResellerLogic && isResellerDiscount ? "Descuento:" : "Descuento forma de pago:"}
          </Col>
          <Col className="text-end col-4">${formatPrice(discountAmount)}</Col>
        </Row>
      )}
      <hr />
      <Row className="fs-3 mb-3">
        <Col className="col-8">
          <b>Total:</b>
        </Col>
        <Col className="text-end col-4">
          <b>${formatPrice(totalCart)}</b>
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          <Button variant="light btn-lg me-1 mb-2" onClick={handleBack}>
            Volver
          </Button>
          <Button
            variant="success btn-lg me-1 mb-2"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Procesando..." : textButton}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentStep;
